<template>
    <div>
        <h1 class="page-title">
            Style Guide
        </h1>

        <!-- Text elements -->
        <div class="row">
            <div class="col-12 col-lg-6 mb-5">
                <!-- Headings -->
                <div class="card h-100">
                    <div class="card__body">
                        <h1 class="card__title color-primary">
                            Headings
                        </h1>
                        <h1>Heading 1</h1>
                        <h2>Heading 2</h2>
                        <h3>Heading 3</h3>
                        <h4>Heading 4</h4>
                        <h5>Heading 5</h5>
                        <h6>Heading 6</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 mb-5">
                <!-- Paragraph -->
                <div class="card h-100">
                    <div class="card__body">
                        <h1 class="card__title color-primary">
                            Paragraph
                        </h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer at iaculis risus. Vivamus posuere erat sit amet sapien tincidunt, et convallis sem interdum. Sed vitae nulla non elit porta tempus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Integer in lectus nec sem luctus congue. Nam sodales odio laoreet molestie congue. Suspendisse laoreet justo eu efficitur aliquet. Nulla a accumsan elit.</p>
                        <p>Praesent id posuere dolor. Sed porta dui sapien, vel sagittis enim fermentum sed. Proin scelerisque nunc vitae massa elementum posuere. Curabitur pellentesque sapien nec maximus interdum. Sed fermentum lorem velit, sed interdum ante convallis eu. Cras lobortis velit nec massa egestas, in fringilla lectus viverra. Quisque in lorem sed justo dignissim fermentum at eget nisi. Cras at accumsan arcu. Maecenas ultrices dolor ac augue tincidunt euismod. Fusce in odio venenatis, ultricies tortor sodales, faucibus justo. Aliquam sollicitudin nunc consequat odio ultricies, non varius elit scelerisque. Sed vel mi nunc.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Colours & Buttons -->
        <div class="row">
            <div class="col-12 col-lg-6 mb-5">
                <!-- Colours -->
                <div class="card h-100">
                    <div class="card__body">
                        <h1 class="card__title color-primary">
                            Colours
                        </h1>
                        <h2 class="color-primary">
                            Colour Primary
                        </h2>
                        <h2 class="color-secondary">
                            Colour Secondary
                        </h2>
                        <h2 class="color-sell">
                            Colour Sell
                        </h2>
                        <h2 class="color-let">
                            Colour Let
                        </h2>
                        <h2 class="color-rent">
                            Colour Rent
                        </h2>
                        <h2 class="color-buy">
                            Colour Buy
                        </h2>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 mb-5">
                <!-- Buttons -->
                <div class="card h-100">
                    <div class="card__body">
                        <h1 class="card__title color-primary">
                            Buttons
                        </h1>
                        <div class="mb-3">
                            <button
                                type="button"
                                class="btn"
                            >
                                Button Default
                            </button>
                            <button
                                type="button"
                                class="ml-3 btn btn--outline"
                            >
                                Button Default
                            </button>
                        </div>
                        <div class="mb-3">
                            <button
                                type="button"
                                class="btn btn--primary"
                            >
                                Button Primary
                            </button>
                            <button
                                type="button"
                                class="ml-3 btn btn--primary btn--outline"
                            >
                                Button Primary
                            </button>
                        </div>
                        <div class="mb-3">
                            <button
                                type="button"
                                class="btn btn--secondary"
                            >
                                Button Secondary
                            </button>
                            <button
                                type="button"
                                class="ml-3 btn btn--secondary btn--outline"
                            >
                                Button Secondary
                            </button>
                        </div>
                        <div class="mb-3">
                            <button
                                type="button"
                                class="btn btn--sell"
                            >
                                Button Sell
                            </button>
                            <button
                                type="button"
                                class="ml-3 btn btn--sell btn--outline"
                            >
                                Button Sell
                            </button>
                        </div>
                        <div class="mb-3">
                            <button
                                type="button"
                                class="btn btn--let"
                            >
                                Button Let
                            </button>
                            <button
                                type="button"
                                class="ml-3 btn btn--let btn--outline"
                            >
                                Button Let
                            </button>
                        </div>
                        <div class="mb-3">
                            <button
                                type="button"
                                class="btn btn--buy"
                            >
                                Button Buy
                            </button>
                            <button
                                type="button"
                                class="ml-3 btn btn--buy btn--outline"
                            >
                                Button Buy
                            </button>
                        </div>
                        <div class="mb-3">
                            <button
                                type="button"
                                class="btn btn--rent"
                            >
                                Button Rent
                            </button>
                            <button
                                type="button"
                                class="ml-3 btn btn--rent btn--outline"
                            >
                                Button Rent
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Breadcrumb & Forms -->
        <div class="row">
            <div class="col-12 col-lg-6 mb-5">
                <!-- Breadcrumb -->
                <div class="card h-100 bg-light-grey">
                    <div class="card__body px-0">
                        <h1 class="card__title color-primary">
                            Breadcrumb
                        </h1>
                        <nav class="breadcrumbs">
                            <p>
                                <a
                                    href="#"
                                    itemprop="url"
                                >
                                    Grandparent
                                </a>
                                <span class="seperator" />
                                <a
                                    href="#"
                                    itemprop="url"
                                >
                                    Parent
                                </a>
                                <span class="seperator" />
                                <span class="current-page">Child Page</span>
                            </p>
                        </nav>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 mb-5">
                <!-- Forms -->
                <div class="card h-100 bg-light-grey">
                    <div class="card__body px-0">
                        <h1 class="card__title color-primary">
                            Forms
                        </h1>

                        <form>
                            <!-- Text field -->
                            <div class="field-wrap">
                                <label
                                    for="text-field"
                                >
                                    Text Field
                                </label>
                                <div class="field-wrap__input">
                                    <input
                                        id="text-field"
                                        type="text"
                                        name="text-field"
                                        placeholder="Text Field placeholder"
                                    >
                                </div>
                            </div>

                            <!-- Email field -->
                            <div class="field-wrap">
                                <label
                                    for="text-field"
                                >
                                    Email field
                                </label>
                                <div class="field-wrap__input">
                                    <input
                                        id="email-field"
                                        type="email"
                                        name="email-field"
                                        placeholder="Email Field placeholder"
                                    >
                                </div>
                            </div>

                            <!-- Text field -->
                            <div class="field-wrap">
                                <label
                                    for="number-field"
                                >
                                    Number Field
                                </label>
                                <div class="field-wrap__input">
                                    <input
                                        id="number-field"
                                        type="number"
                                        name="number-field"
                                        placeholder="Number Field placeholder"
                                    >
                                </div>
                            </div>

                            <!-- Textarea field -->
                            <div class="field-wrap">
                                <label
                                    for="textarea-field"
                                >
                                    Textarea field
                                </label>
                                <div class="field-wrap__input">
                                    <textarea
                                        id="textarea-field"
                                        type="textarea"
                                        name="textarea-field"
                                        placeholder="Textarea Field placeholder"
                                        rows="5"
                                    />
                                </div>
                            </div>

                            <!-- Select field -->
                            <div class="field-wrap">
                                <label
                                    for="select-field"
                                >
                                    Select field
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="select-field"
                                        name="select-field"
                                    >
                                        <option
                                            disabled
                                            selected
                                            hidden
                                        >
                                            Select a value
                                        </option>
                                        <option>A</option>
                                        <option>B</option>
                                        <option>C</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Prepend icon field -->
                            <div class="field-wrap">
                                <label
                                    for="prepend-field"
                                >
                                    Prepend icon field
                                </label>
                                <div class="field-wrap__input field-wrap__input--prepend">
                                    <input
                                        id="prepend-field"
                                        type="text"
                                        name="prepend-field"
                                        placeholder="Prepend icon field"
                                    >
                                    <div class="field-wrap__input-icon">
                                        <SVGSprite
                                            name="messages"
                                            class="form-icon"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- Prepend icon field with fill -->
                            <div class="field-wrap">
                                <label
                                    for="prepend-field"
                                >
                                    Prepend icon field w/fill
                                </label>
                                <div class="field-wrap__input field-wrap__input--prepend field-wrap__input--prepend-fill">
                                    <input
                                        id="prepend-field"
                                        type="text"
                                        name="prepend-field"
                                        placeholder="Prepend icon field"
                                    >
                                    <div class="field-wrap__input-icon">
                                        <SVGSprite
                                            name="messages"
                                            class="form-icon"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- Append icon field -->
                            <div class="field-wrap">
                                <label
                                    for="append-field"
                                >
                                    Append icon field
                                </label>
                                <div class="field-wrap__input field-wrap__input--append">
                                    <input
                                        id="append-field"
                                        type="text"
                                        name="append-field"
                                        placeholder="Append icon field"
                                    >
                                    <div class="field-wrap__input-icon">
                                        <SVGSprite
                                            name="search"
                                            class="form-icon"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- Append icon field  with fill -->
                            <div class="field-wrap">
                                <label
                                    for="append-field"
                                >
                                    Append icon field w/fill
                                </label>
                                <div class="field-wrap__input field-wrap__input--append field-wrap__input--append-fill">
                                    <input
                                        id="append-field"
                                        type="text"
                                        name="append-field"
                                        placeholder="Append icon field"
                                    >
                                    <div class="field-wrap__input-icon">
                                        <SVGSprite
                                            name="search"
                                            class="form-icon"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- Checkbox field -->
                            <p>Checkbox field</p>
                            <div class="row mb-3">
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--checkbox">
                                            <input
                                                id="checkbox-field"
                                                type="checkbox"
                                                true-value="yes"
                                                false-value="no"
                                                name="checkbox-field"
                                            >
                                            <label for="checkbox-field"><span class="check-element" />Checkbox label</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--checkbox">
                                            <input
                                                id="checkbox-field-2"
                                                type="checkbox"
                                                true-value="yes"
                                                false-value="no"
                                                name="checkbox-field"
                                            >
                                            <label for="checkbox-field-2"><span class="check-element" />Checkbox label 2</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--checkbox">
                                            <input
                                                id="checkbox-field-3"
                                                type="checkbox"
                                                true-value="yes"
                                                false-value="no"
                                                name="checkbox-field"
                                            >
                                            <label for="checkbox-field-3"><span class="check-element" />Checkbox label 3</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--checkbox">
                                            <input
                                                id="checkbox-field-4"
                                                type="checkbox"
                                                true-value="yes"
                                                false-value="no"
                                                name="checkbox-field"
                                            >
                                            <label for="checkbox-field-4"><span class="check-element" />Checkbox label 4</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Radio field -->
                            <p>Radio field</p>
                            <div class="row mb-3">
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--radio">
                                            <input
                                                id="radio-field"
                                                type="radio"
                                                name="radio-field"
                                            >
                                            <label for="radio-field"><span class="check-element" />Radio label</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--radio">
                                            <input
                                                id="radio-field-2"
                                                type="radio"
                                                name="radio-field"
                                            >
                                            <label for="radio-field-2"><span class="check-element" />Radio label 2</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--radio">
                                            <input
                                                id="radio-field-3"
                                                type="radio"
                                                name="radio-field"
                                            >
                                            <label for="radio-field-3"><span class="check-element" />Radio label 3</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="field-wrap">
                                        <div class="field-wrap__input field-wrap__input--radio">
                                            <input
                                                id="radio-field-4"
                                                type="radio"
                                                name="radio-field"
                                            >
                                            <label for="radio-field-4"><span class="check-element" />Radio label 4</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Range sliders -->
                            <div class="field-wrap">
                                <label
                                    for="append-field"
                                >
                                    Range field
                                </label>
                                <div class="field-wrap__input field-wrap__input--range">
                                    <input
                                        id="range-field"
                                        type="range"
                                        name="range-field"
                                        placeholder="Range field"
                                    >
                                </div>
                            </div>

                            <!-- File Upload -->
                            <FileUpload
                                :extensions="['.jpg']"
                                :mimes="['image/jpeg']"
                            />

                            <!-- Password field -->
                            <password
                                v-model="password"
                                :toggle="true"
                                :badge="false"
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table -->
        <div class="row">
            <div class="col-12 mb-5">
                <div class="table-flex table-flex--cell-1-sm table-flex--cell-6-md">
                    <div class="table-flex--header">
                        <div>#</div>
                        <div>Name</div>
                        <div>Date</div>
                        <div>Number</div>
                        <div>Email</div>
                        <div>Other</div>
                    </div>
                    <div>
                        <div>1</div>
                        <div>Sam Smith</div>
                        <div>01/12/2017</div>
                        <div>93845043890385</div>
                        <div>test@test.com</div>
                        <div>Value</div>
                    </div>
                    <div>
                        <div>2</div>
                        <div>Marshall Mathers</div>
                        <div>05/06/2005</div>
                        <div>3945894589034</div>
                        <div>testtestestest@test.com</div>
                        <div>Value</div>
                    </div>
                    <div>
                        <div>3</div>
                        <div>Johanna Krape</div>
                        <div>03/04/2010</div>
                        <div>8347437854564</div>
                        <div>testtestes@test.com</div>
                        <div>Value</div>
                    </div>
                    <div>
                        <div>4</div>
                        <div>Amanda Tapping</div>
                        <div>06/06/1999</div>
                        <div>83475983798547</div>
                        <div>testtesteststset@test.com</div>
                        <div>Value</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- File Upload -->
        <FileUpload
            :extensions="['.jpg']"
            :mimes="['image/jpeg']"
            @file="getSelectedFile"
        />

        <!-- Button component test -->
        <MButton
            :processing="processing"
            :disabled="processing"
            class="text-primary giggity goo"
            @click="processing = true"
        >
            Test Load
        </MButton>
    </div>
</template>

<script>
import Password from 'vue-password-strength-meter';
import FileUpload from '../components/FileUpload';

export default {
    name: 'StyleGuide',
    components: {
        FileUpload,
        Password
    },
    data() {
        return {
            processing: false,
            image: null,
            password: null,
            file: null
        };
    },
    methods: {
        getSelectedFile(file) {
            this.file = file;
        }
    }
};
</script>

<style lang="scss">

</style>
